import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "../pages/Home";
import Main from "../pages/Main";
import Cadastro from "../pages/Cadastro";
import Controle from "../pages/Controle";
import Treinamento from "../pages/Treinamento";
import Pendencia from "../pages/Pendencia";
import Adm from "../pages/Adm";
import Matriz from "../pages/Matriz";
import Relatorios from "../pages/relatorios";
import Inclusao from "../pages/inclusao";
import Nuvem from "../pages/Nuvem";

const RouterApp = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/main" element={<Main />} />
        <Route path="/cadastro" element={<Cadastro />} />
        <Route path="/controle" element={<Controle />} />
        <Route path="/treinamento" element={<Treinamento />} />
        <Route path="/pendencia" element={<Pendencia />} />
        <Route path="/adm" element={<Adm />} />
        <Route path="/relatorios" element={<Relatorios />} />
        <Route path="/inclusao" element={<Inclusao />} />
        <Route path="/matriz" element={<Matriz />} />
        <Route path="/nuvem" element={<Nuvem />} />
      </Routes>
    </BrowserRouter>
  );
};

export default RouterApp;
